import { isSelfOnboarding } from 'components/shared/OnboardingWidget/utils/isSelfOnboarding';

export const isOnboardingWidgetEnabled = async (): Promise<boolean> => {
  const isAdministratorRole = App.isAdministrator() || App.isMasquerading();
  if (!isAdministratorRole || !isSelfOnboarding()) {
    return false;
  }

  const venueId = App.getVenueId();
  const url = `/api/self-sign-up/venue/${venueId}/checklists`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Network response was not ok.');
  }

  const data = await response.json();

  const hasLegacyWidget = data?.checklists?.find(({ type }) => type === 'SELF_SETUP');
  const hasDashboard = data?.checklists?.find(({ type }) => type === 'SELF_SETUP_DASHBOARD');

  return hasLegacyWidget && !hasDashboard;
};
